import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

// 语言切换与 antd 语言包由 App 内统一管理（见 App.js 的 LangContext + ConfigProvider）
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
